import { parseApiData } from "go-core/api/parseApiData";
import { restSecurityApi } from "go-security/services/Api/api";
import { ProductPackageApi } from "../../../pages/App/pages/Admin/services/types";

class adminApi {
	static getProductPackages(
		params?: Record<string, any>,
		options?: Record<string, any>
	): Promise<ProductPackageApi[]> {
		return parseApiData(
			restSecurityApi.get("/product_packages", {
				params,
				cancelToken: options?.cancelToken,
			})
		);
	}

	static getProductPackage(
		id: string,
		params?: Record<string, any>,
		options?: Record<string, any>
	): Promise<ProductPackageApi> {
		return parseApiData(
			restSecurityApi.get(`/product_packages/${id}`, {
				params,
				cancelToken: options?.cancelToken,
			})
		);
	}

	static async createProductPackage(
		data: ProductPackageApi,
		params?: Record<string, any>
	): Promise<ProductPackageApi> {
		return parseApiData(restSecurityApi.post("product_packages", data, { params }));
	}

	static async updateProductPackage(
		id: string,
		data: ProductPackageApi,
		params?: Record<string, any>
	): Promise<ProductPackageApi> {
		return parseApiData(restSecurityApi.put(`product_packages/${id}`, data, { params }));
	}

	static async deleteProductPackage(id: number): Promise<{}> {
		return restSecurityApi.delete(`product_packages/${id}`);
	}
}

export { adminApi };
